__turbopack_context__.v({
  "ascii": "BNLdwq_ascii",
  "cell": "BNLdwq_cell",
  "decode-split": "BNLdwq_decode-split",
  "ghost": "BNLdwq_ghost",
  "glyph": "BNLdwq_glyph",
  "layer": "BNLdwq_layer",
  "root": "BNLdwq_root",
  "singleLine": "BNLdwq_singleLine",
  "sizer": "BNLdwq_sizer",
  "srOnly": "BNLdwq_srOnly",
  "word": "BNLdwq_word",
});
